import React from "react";
import Article from "./Article";
import { PostThreadProps } from "./types";

const PostThread = (props: PostThreadProps) => <Article {...props} />;

export default PostThread;
export type {
  LinkMetadata,
  PostThreadData,
  PostThreadProps,
  ReplyData,
} from "./types";
